module.exports = __webpack_public_path__ + "static/media/coupon.1c1b23a3.svg";